import { createAction, props } from "@ngrx/store";
import { RollinModel } from "src/app/model/rollin.model";

export const DataSavedAction = createAction('[Review Form] set data saved');

export const CompleteRequestAction = createAction('[Review Form] Complete request',
    props<{ data: RollinModel }>());